import firebase from 'firebase'

// Initialize Firebase
export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyDvzCLnTANQ8hhGZ7iO1OZZ7WbaMuP844o",
    authDomain: "skovbokarate.firebaseapp.com",
    databaseURL: "https://skovbokarate.firebaseio.com",
    projectId: "project-7400542431161414774",
    storageBucket: "project-7400542431161414774.appspot.com",
    messagingSenderId: "998744773205",

    timestampsInSnapshots: true

}

